export default __webpack_public_path__ + "static/media/logomark.8aff0fb8.svg";